import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { pathFor, type Lang } from '../../../router/paths';

export default function Rooms() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const lang: Lang = i18n.language === 'en' ? 'en' : 'de';
  const roomsPath = pathFor('rooms', lang);

  return (
    <section id="zimmer" className="py-12 sm:py-20 px-4 sm:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif text-gray-800 mb-4">
            {t('roomsPreviewTitle')}
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto">
            {t('roomsPreviewLead')}
          </p>
        </div>

        <div className="relative w-full h-[320px] sm:h-[450px] md:h-[600px] rounded-2xl overflow-hidden shadow-xl group cursor-pointer" onClick={() => navigate(roomsPath)}>
          <img
            src="/images/zimmer/DZ_Wuermtal_2_2025_kl.jpg"
            alt="Doppelzimmer Würmtal mit Doppelbett – Hotel Alpenhof Gauting bei München"
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent"></div>

          <div className="absolute bottom-0 left-0 right-0 p-5 sm:p-10 flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 sm:gap-6">
            <div>
              <p className="text-amber-300 text-xs sm:text-sm font-medium uppercase tracking-widest mb-1 sm:mb-2">{t('roomsPreviewKicker')}</p>
              <h3 className="text-white text-xl sm:text-3xl md:text-4xl font-serif leading-tight">
                {t('roomsPreviewHeadline')}
              </h3>
            </div>
            <button
              onClick={(e) => { e.stopPropagation(); navigate(roomsPath); }}
              className="whitespace-nowrap cursor-pointer bg-amber-600 hover:bg-amber-700 text-white px-6 sm:px-8 py-3 rounded-md text-sm font-semibold transition-all duration-300 inline-flex items-center gap-2 shadow-lg hover:shadow-amber-700/30 sm:hover:scale-105"
            >
              {t('roomsPreviewCta')}
              <i className="ri-arrow-right-line text-base"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
